import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import {
  KcDataService
} from '../../../kc-data.service'
import { KcValidationService } from '../../../kc-validation.service'
import { TranslationService } from '@emilfreydigital/transifex-angular'
import { TransifexService } from '@inside-hub-app/customer-portal-shared'
import { KcSetPasswordViewData, KcRealmData, KcClientData } from '../../../interfaces/kc-data.interface'

@Component({
  selector: 'customer-portal-app-revolution-set-password',
  templateUrl: './revolution-set-password.component.html'
})
export class RevolutionSetPasswordComponent implements OnInit {
  showPassword = false
  showConfirmedPassword = false
  public showPasswordUrl = 'assets/icons/visibility_24px.svg'
  public hidePasswordUrl = 'assets/icons/visibility_off_24px.svg'

  constructor(
    private readonly kcDataService: KcDataService,
    private readonly kcValidationService: KcValidationService,
    private readonly transifexTranslationsService: TranslationService,
    public transifexService: TransifexService
  ) {
    this.form = new FormGroup(
      {
        password: new FormControl<string | null>(null, [
          this.kcValidationService.password
        ]),
        passwordConfirm: new FormControl<string | null>(null, []),
        accept: new FormControl<boolean | null>(false, [Validators.requiredTrue]),
        accept2: new FormControl<boolean | null>(false, [Validators.requiredTrue])
      },
      { validators: this.kcValidationService.checkPasswords }
    )
  }

  @ViewChild('setPasswordForm', { static: true })
  private readonly formRef: ElementRef

  public form

  public realmData: KcRealmData
  public clientData: KcClientData
  public viewData: KcSetPasswordViewData
  public submitting: boolean

  ngOnInit() {
    this.realmData = this.kcDataService.getRealmData()
    this.clientData = this.kcDataService.getClientData()
    this.viewData = this.kcDataService.getViewData() as KcSetPasswordViewData
  }

  public set() {
    this.submitting = true

    // submit form
    const formElement = this.formRef.nativeElement as HTMLFormElement
    formElement.submit()
  }

  public toggleShowPassword() {
    this.showPassword = !this.showPassword
  }

  public toggleShowConfirmedPassword() {
    this.showConfirmedPassword = !this.showConfirmedPassword
  }

  getTranslation1(): string {
    return this.transifexTranslationsService.translate(
      "I have read the general <a href='https://www.emilfrey.de/agb' target='_blank'>Terms and Conditions</a> of Emil Frey Digital Services GmbH and agree to their validity.",
      {
        _key: 'customerPortal.kc.set-password.accept',
        _tags: 'kc-forms, 3.1'
      }
    )
  }

  getTranslation2(): string {
    return this.transifexTranslationsService.translate(
      "I hereby confirm that I have read and taken note of the <a href='https://www.emilfrey.de/datenschutz' target='_blank'>Privacy Policy</a>.",
      {
        _key: 'customerPortal.kc.set-password.accept2',
        _tags: 'kc-forms, 3.1'
      }
    )
  }
}
